// Field configurations for Program Fee V2

export const PROGRAM_FEE_2_CONSTANTS = {
  // ─── Component-Level Fields (FieldsFormatter) ───────────────────────────
  PROGRAM_FEE_FIELDS_CONFIG: [
    // Title section
    {
      fieldName: "title_1",
      label: "Title Line 1",
      value: "Investment in",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Investment in",
      required: false,
      defaultValue: "Investment in",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "rgba(34,34,34,0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Title 1 text color",
      required: false,
      defaultValue: "rgba(34,34,34,0.8)",
    },
    {
      fieldName: "title_2",
      label: "Title Line 2 (Gradient)",
      value: "Your Future",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Your Future",
      required: false,
      defaultValue: "Your Future",
    },
    {
      fieldName: "title_2_gradient_from",
      label: "Title 2 Gradient From",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Gradient start color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_2_gradient_to",
      label: "Title 2 Gradient To",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Gradient end color",
      required: false,
      defaultValue: "#02A7B6",
    },

    // Table gradient
    {
      fieldName: "table_gradient_from",
      label: "Fee Table Gradient From",
      value: "#342b7c",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Table gradient start",
      required: false,
      defaultValue: "#342b7c",
    },
    {
      fieldName: "table_gradient_to",
      label: "Fee Table Gradient To",
      value: "#02a7b6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Table gradient end",
      required: false,
      defaultValue: "#02a7b6",
    },

    // Metadata section title
    {
      fieldName: "metadata_title",
      label: "Sidebar Title",
      value: "What You Get:",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. What You Get:",
      required: false,
      defaultValue: "What You Get:",
    },
    {
      fieldName: "metadata_title_color",
      label: "Sidebar Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Sidebar title text color",
      required: false,
      defaultValue: "#000000",
    },

    // Background
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: false,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Diagonal Gradient)", value: "variant_1" },
        { label: "Variant 2 (Angled Gradient)", value: "variant_2" },
        { label: "Variant 3 (Solid Color)", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB54",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB54",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Section background color",
      required: false,
      defaultValue: "#000000",
    },

    // CTA button
    {
      fieldName: "cta_text",
      label: "CTA Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Button Text Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "CTA text color",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "cta_gradient_from",
      label: "CTA Gradient From",
      value: "#02a7b6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "CTA gradient start",
      required: false,
      defaultValue: "#02a7b6",
    },
    {
      fieldName: "cta_gradient_to",
      label: "CTA Gradient To",
      value: "#342b7c",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "CTA gradient end",
      required: false,
      defaultValue: "#342b7c",
    },

    // Status
    {
      fieldName: "status",
      label: "Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  // ─── What You Get Items (metadata) ──────────────────────────────────────
  METADATA_FIELDS_CONFIG: [
    {
      header: "Label",
      fieldName: "label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. UGC-Recognized MBA Degree",
      required: true,
    },
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (optional)",
      required: false,
    },
    {
      header: "Icon Alt",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon alt text",
      required: false,
    },
    {
      header: "Text Color",
      fieldName: "text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
      defaultValue: 0,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Active/Inactive",
      required: false,
      defaultValue: true,
    },
  ],

  // ─── Feature Cards (metadata_1) ─────────────────────────────────────────
  METADATA_1_FIELDS_CONFIG: [
    {
      header: "Title",
      fieldName: "label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. No-Cost EMI Options Available",
      required: true,
    },
    {
      header: "Description",
      fieldName: "description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Flexible payment plans",
      required: false,
    },
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      required: false,
    },
    {
      header: "Icon Alt",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon alt text",
      required: false,
    },
    {
      header: "Text Color",
      fieldName: "text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description Color",
      fieldName: "value_text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "rgba(0,0,0,0.7)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
      defaultValue: 0,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Active/Inactive",
      required: false,
      defaultValue: true,
    },
  ],

  // ─── Per-Category Fields (rendered by CategoryManager) ──────────────────
  // `tab_group` groups categories under outer tab(s) for Variant 3's multi-level
  // tabs. Use "/" to nest, e.g. "Indian Student" or "Indian Student/Postgraduate".
  // Leave empty for Variant 1 / a single tab level.
  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "tab_group",
      label: "Tab Group (Variant 3 — outer tab path, '/'-separated to nest)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Indian Student",
      required: false,
      defaultValue: "",
    },
  ],

  // ─── Category Fee Rows (metadata inside each category) ──────────────────
  CATEGORY_METADATA_FIELDS_CONFIG: [
    {
      header: "Label",
      fieldName: "label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Year 1",
      required: true,
    },
    {
      header: "Value",
      fieldName: "value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. ₹ 10,00,000",
      required: false,
    },
    {
      header: "Is Total",
      fieldName: "is_total",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Mark as total row",
      required: false,
      defaultValue: false,
    },
    {
      header: "Text Color",
      fieldName: "text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#ffffff",
      required: false,
      defaultValue: "",
    },
    {
      header: "Value Color",
      fieldName: "value_text_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#ffffff",
      required: false,
      defaultValue: "",
    },
    {
      header: "Value Font Size",
      fieldName: "value_font_size",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 64px (for total rows)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
      defaultValue: 0,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Active/Inactive",
      required: false,
      defaultValue: true,
    },
  ],
};
